var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: {
          x: "2",
          y: "2",
          width: "6",
          height: "16",
          rx: "2",
          fill: _vm.color
        }
      }),
      _c("rect", {
        attrs: {
          x: "9",
          y: "2",
          width: "6",
          height: "20",
          rx: "2",
          fill: _vm.color
        }
      }),
      _c("rect", {
        attrs: {
          x: "16",
          y: "2",
          width: "6",
          height: "10",
          rx: "2",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }